import { createSearchParams, useNavigate } from 'react-router-dom';

import { Box, useTheme } from '@mui/material';
import Button from '@mui/material/Button';

import { AppIcon } from '~components/shared/app-icon/app-icon';
import { ModalWrapper } from '~components/shared/modals/modal-wrapper';
import { AppTypography } from '~components/ui/typography/app-typography';

import { useSpecificModal } from '~hooks/use-specific-modal';

import { ROUTES } from '~app/router/routes';

import { ReactComponent as IconUserAdd } from '~assets/icons/icon-user-add.svg';
import { ReactComponent as IconUserFile } from '~assets/icons/icon-user-file.svg';

export const TenantCreateModal = () => {
  const theme = useTheme();
  const { closeSpecificModal, activeSpecificModal } = useSpecificModal();
  const navigate = useNavigate();

  const params = activeSpecificModal.data?.params ?? {};

  const handleClickActiveTenant = () => {
    closeSpecificModal();
    navigate({
      pathname: ROUTES.NEW_LEASE,
      search: createSearchParams(params).toString(),
    });
  };

  const handleClickInactiveTenant = () => {
    closeSpecificModal();
    navigate(ROUTES.NEW_TENANT);
  };

  return (
    <ModalWrapper open={true} handleClose={closeSpecificModal}>
      <Box textAlign={'center'}>
        {/*<AppTypography size={'h7'} mb={2}>Якого орендаря хочете додати?</AppTypography>*/}
        <AppTypography
          size={{ xs: 'body-md', sm: 'body-lg' }}
          weight={'semibold'}
          mb={2}
          color={'fog.25'}
        >
          Як хочете додати орендаря?
        </AppTypography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: { xs: 1, sm: 2 },
            mb: 2,
          }}
        >
          <Box
            role={'button'}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: { xs: 1, sm: 2 },
              borderRadius: theme.spacing(2),
              border: `1px solid ${theme.palette.fog['85']}`,
              cursor: 'pointer',
              width: '50%',

              '&:hover': {
                background: theme.palette.primaryTokens['10'],
                border: `1px solid ${theme.palette.primaryTokens['50']}`,
              },
            }}
            onClick={handleClickActiveTenant}
          >
            <Box
              sx={{
                width: { xs: 46, sm: 52 },
                height: { xs: 46, sm: 52 },
                borderRadius: '50%',
                background: theme.palette.primaryTokens['50'],
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 1,
              }}
            >
              <AppIcon component={IconUserAdd} size={{ xs: 22, sm: 24 }} />
            </Box>
            <AppTypography
              size={{ xs: 'body-sm', sm: 'body-md' }}
              weight={'semibold'}
              mb={0.75}
              color={'fog.30'}
            >
              Додати активного орендаря
            </AppTypography>
            <AppTypography size={'body-caption'} color={'fog.40'}>
              Створіть договір та вкажіть орендаря для нагадувань
            </AppTypography>
            {/*<AppTypography size={'body-sm'}>Одразу створіть договір та вкажіть орендаря</AppTypography>*/}
          </Box>

          <Box
            role={'button'}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: { xs: 1, sm: 2 },
              borderRadius: theme.spacing(2),
              border: `1px solid ${theme.palette.fog['85']}`,
              cursor: 'pointer',
              width: '50%',

              '&:hover': {
                background: theme.palette.orange['10'],
                border: `1px solid ${theme.palette.orange['75']}`,
              },
            }}
            onClick={handleClickInactiveTenant}
          >
            <Box
              sx={{
                width: { xs: 46, sm: 52 },
                height: { xs: 46, sm: 52 },
                borderRadius: '50%',
                background: theme.palette.orange['50'],
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 1,
              }}
            >
              <AppIcon component={IconUserFile} size={{ xs: 22, sm: 24 }} />
            </Box>
            <AppTypography
              size={{ xs: 'body-sm', sm: 'body-md' }}
              weight={'semibold'}
              mb={0.75}
              color={'fog.30'}
            >
              Додати орендаря без договору
            </AppTypography>
            <AppTypography size={'body-caption'} color={'fog.40'}>
              Збережіть історію чи контакти, без активного договору
            </AppTypography>
          </Box>
        </Box>

        <Button variant={'outlined'} fullWidth onClick={closeSpecificModal}>
          Скасувати
        </Button>
      </Box>
    </ModalWrapper>
  );
};
